import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationFR from "./locales/fr/translation.json";
import translationAR from "./locales/ar/translation.json";

const resources = {
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

const savedLanguage = localStorage.getItem("language");

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage || "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
